import React from "react";
import { FormattedMessage, injectIntl, defineMessages } from "react-intl";
import {
  IconArrowRight,
  IconBlockUser,
  IconChatE2E,
  IconChangeBackgroundImage,
  IconEyeDisable,
  IconImage,
  IconLeave,
  IconNotification,
  IconPerson,
  IconPersonDisable,
  IconSearch,
  IconSecurity,
  IconTrash,
  IconQRCode,
  IconChangeAvatarImage,
  IconChangeWallpaper,
  IconChatBackground,
} from "../../icons/svg";
import { Topic } from "../../tinode/topic";
import { SCREEN } from "../info-view-content.jsx";
import LetterTile from "../letter-tile.jsx";
import Switch from "../switch.jsx";
import { GROUP_MEMBER_VIEW_TYPE, IQ_RESULT_CODE, NODE_TYPE_MESSAGE, GROUP_PRIVATE_STATE } from "../../tinode/constants";
import MessagesUtil from "../../tinode/messagesUtils";
import AvatarCrop from "../avatar-crop.jsx";
import fileService from "../../services/file.js";
import BlockChatServices from "../../services/blockchat.js";
import {
  AVATAR_SIZE,
  MAX_AVATAR_BYTES,
  MAX_EXTERN_ATTACHMENT_SIZE,
  MAX_TITLE_LENGTH,
} from "../../config.js";
import {
  imageScaled,
  blobToBase64,
  makeImageUrl,
} from "../../lib/blob-helpers.js";
import Helpers from "../../lib/helpers.js";
import { profile } from "../../stores/storages/ProfileStorage.js";
import { async } from "regenerator-runtime";
import YetAnotherLightbox from "./yet-image-lightbox.jsx";
import "yet-another-react-lightbox/styles.css"

const messages = defineMessages({
  button_leave_group: {
    id: "button_leave_group",
    defaultMessage: "Leave group",
    description: "Flat button Leave group",
  },
  leave_group_warning: {
    id: "leave_group_warning",
    defaultMessage:
      "Are you sure you want to leave this group? It cannot be undone.",
    description: "Alert dialog warning when leaving group",
  },
  rename_empty_error: {
    id: "rename_empty_error",
    defaultMessage: "Group name cannot be empty",
    description: "Group name cannot be empty",
  },
  rename_length_error: {
    id: "rename_length_error",
    defaultMessage: "The maximum number of characters is 30",
    description: "The maximum number of characters is 30",
  },
  notify_rename_group: {
    id: 'notify_rename_group',
    defaultMessage: 'You renamed the group to "{groupName}"',
    description: 'Notice of group name change by creator',
  },
  notify_rename_group_failed: {
    id: 'notify_rename_group_failed',
    defaultMessage: 'Rename group failed',
    description: 'Notice of group name change failed',
  },
  clear_messages_warning: {
    id: 'clear_messages_warning',
    defaultMessage: 'Are you sure you want to clear all messages? It cannot be undone.',
    description: 'Alert dialog warning when deleting all messages.'
  },
  clear_messages: {
    id: 'menu_item_clear_messages',
    defaultMessage: 'Clear messages',
    description: 'Delete all messages'
  },
  notify_changed_avatar_group: {
    id: 'notify_changed_avatar_group',
    defaultMessage: 'You changed group profile photo',
    description: 'Changed group profile photo'
  },
  info_disband_group: {
    id: 'info_disband_group',
    defaultMessage: 'Disband the group',
    description: 'Disband the group'
  },
  content_disband_group: {
    id: 'content_disband_group',
    defaultMessage: 'All member and chat history will be removed. This CANNOT be undone. Are you sure you want to delete the group?',
    description: 'All member and chat history will be removed. This CANNOT be undone. Are you sure you want to delete the group?'
  },
  unblockUser: {
    id: 'unblockUser',
    defaultMessage: 'Unblocked {phoneName} successfully',
    description: 'Unblocked successfully'
  },
  blockUser_content: {
    id: 'blockUser_content',
    defaultMessage: 'Blocked {phoneName} successfully',
    description: 'Blocked successfully'
  },
  only_admin_can_use_this_feature_warning: {
    id: 'only_admin_can_use_this_feature_warning',
    defaultMessage: 'Only Admin can use this feature',
    description: 'Only Admin can use this feature'
  },
  you: {
    id: 'calls_you_label',
    defaultMessage: 'You',
  },
  info_qr_code_invite: {
    id: 'info_qr_code_invite',
    defaultMessage: 'QR code, group join link',
  },
});

class Info extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      avatar: '',
      edit: false,
      isEditAvatar: true,
      name: "",
      fileAvatar: "",
      pathAvatar: "",
      fileAvatarName: "",
      imageUrl: null,
      uploadUrl: null,
      newAvatar: null,
      newAvatarMime: null,
      isGroupPrivate: false,
      isBlockUser: false,
      isE2EChat: false,
      isOpenLightbox: false,
      indexImage: -1,
      listImagesLightBox: [],
    }

    this.handleShowEdit = this.handleShowEdit.bind(this);
    this.handleHideEdit = this.handleHideEdit.bind(this);
    this.handleShowGroupMembers = this.handleShowGroupMembers.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleLeaveGroup = this.handleLeaveGroup.bind(this);
    this.handleSetTitle = this.handleSetTitle.bind(this);
    this.renameGroupMessage = this.renameGroupMessage.bind(this);
    this.handleSetNotification = this.handleSetNotification.bind(this);
    this.handleOnChangeAvatarButtonClick = this.handleOnChangeAvatarButtonClick.bind(this);
    this.handleOnFileSelectedChange = this.handleOnFileSelectedChange.bind(this);
    this.handleAvatarCropped = this.handleAvatarCropped.bind(this);
    this.handleAvatarCropCancel = this.handleAvatarCropCancel.bind(this);
    this.uploadAvatar = this.uploadAvatar.bind(this);
    this.uploadWithBaseUrl = this.uploadWithBaseUrl.bind(this);
    this.handleImageChanged = this.handleImageChanged.bind(this);
    this.handleDeleteHistoryMessage = this.handleDeleteHistoryMessage.bind(this);
    this.deleteMessages = this.deleteMessages.bind(this);
    this.handleDisbandTheGroup = this.handleDisbandTheGroup.bind(this);
    this.isGroupOwner = this.isGroupOwner.bind(this);
    this.handleToggleBlockChat = this.handleToggleBlockChat.bind(this);
    this.handleSetUserInfo = this.handleSetUserInfo.bind(this);
    this.setIsOpenLightbox = this.setIsOpenLightbox.bind(this);
    this.handleSetPrivateGroup = this.handleSetPrivateGroup.bind(this);
    this.getPrivateGroup = this.getPrivateGroup.bind(this);
    this.handleToggleE2EChat = this.handleToggleE2EChat.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.topicAvatar != this.props.topicAvatar) {
      this.setState({
        avatar: this.props.topicAvatar
      })
    }
    if (prevProps.isBlockUser != this.props.isBlockUser) {
      this.setState({
        isBlockUser: this.props.isBlockUser
      })
    }
  }

  componentDidMount() {
    this.handleSetTitle();
    this.handleSetUserInfo();

    if (Topic.isGroupTopicName(this.props.topic)) {
      this.setState({
        isGroupPrivate: this.getPrivateGroup()
      })
    }

  }

  getPrivateGroup() {
    const topicInfo = this.props.tinode.getTopic(this.props.topic);
    const isGroupPrivate = topicInfo?.public?.security === GROUP_PRIVATE_STATE.PRIVATE

    return isGroupPrivate
  }

  handleSetTitle() {
    const { tinode, topic } = this.props;
    const topicInfo = tinode.getTopic(topic);
    const title = Topic.getTopicName(topicInfo);
    const avatar = makeImageUrl(topicInfo.public ? topicInfo.public.photo : null)
    this.setState({
      name: title,
      avatar,
    });
  }

  handleSetUserInfo() {
    const { tinode, topic, topic: topicId } = this.props;
    const topicInfo = tinode.getTopic(topic);
    const userSelected = Topic.getThreadId(topicId)
    const isBlockUser = topicInfo?.isBlockUser ? topicInfo.isBlockUser : false;
    const isCryptE2E = topicInfo?.isCrypt ? topicInfo.isCrypt : false;
    // const listBlockChats = profile.listBlockChat
    // let isBlockUser = false;
    // if (Array.isArray(listBlockChats) && listBlockChats.length > 0) {
    //   isBlockUser = !!listBlockChats.find(user => user === userSelected)
    // }
    this.setState({
      isBlockUser: isBlockUser,
      isCryptE2E: isCryptE2E,
    });
  }

  handleShowEdit() {
    const { tinode, topic } = this.props;
    const topicInfo = tinode.getTopic(topic);
    const title = Topic.getTopicName(topicInfo);
    this.setState({
      edit: true,
      name: title,
    });
  }

  renameGroupMessage = () => {
    const { tinode, topic, topic: topicId } = this.props;
    const { formatMessage } = this.props.intl;
    const topicInfo = tinode.getTopic(topic);
    const oldGroupName = Topic.getTopicName(topicInfo);
    const newgroupname = this.state.name;
    if (oldGroupName === newgroupname) {
      return;
    }

    if (newgroupname.trim().length <= 0) {
      this.handleSetTitle();
      Helpers.showErrorToasts(formatMessage(messages.rename_empty_error))
      return;
    }
    if (newgroupname.trim().length > 30) {
      Helpers.showErrorToasts(formatMessage(messages.rename_length_error))
      this.handleSetTitle();
      return;
    }
    const id = MessagesUtil.xmppid();
    tinode.sendRenameGroup(topic, newgroupname.trim(), id).then((resultData) => {
      const { formatMessage } = this.props.intl;
      switch (resultData.errorCode) {
        case IQ_RESULT_CODE.SUCCESS: {
          const body = formatMessage(messages.notify_rename_group, { groupName: resultData.groupName })
          this.props.tinode.addMessageNotify(topicId, NODE_TYPE_MESSAGE.GROUPCHAT, {
            body,
            timesend: new Date().getTime(),
            id,
          })
          break;
        }
        default: {
          Helpers.showErrorToasts(formatMessage(messages.notify_rename_group_failed))
          break
        }
      }
    });
  };

  handleHideEdit() {
    this.setState({
      edit: false,
    });
  }

  handleShowGroupMembers(e) {
    e.preventDefault();
    this.props.handleShowGroupMembers({
      groupView: GROUP_MEMBER_VIEW_TYPE.VIEW_MEMBER,
      topicGroup: this.props.topic,
      groupMembers: this.props.groupMembers,
    });
  }

  handleLeaveGroup(e) {
    e.preventDefault();

    const { formatMessage } = this.props.intl;
    this.props.onShowAlert(
      formatMessage(messages.button_leave_group), // title
      formatMessage(messages.leave_group_warning), // content
      (_) => this.props.leaveGroup(), // onConfirm
      null, // "OK"
      true, // Show Reject button
      null // "Cancel"
    );
  }

  onChange(e) {
    const name = e.target.value;
    this.setState({
      name: name,
    });
  }

  handleSetNotification() {
    const { topic: tp, tinode } = this.props;
    const topic = tinode.getTopicByName(tp);
    const mode = topic.acs.isMuted() ? '+P' : '-P';
    topic.updateMode(null, mode);
  }

  handleToggleBlockChat = async () => {
    const { isBlockUser } = this.state;
    const { formatMessage } = this.props.intl;
    const { tinode, topic: topicId } = this.props;
    const topic = tinode.getTopicByName(topicId);
    const userSelected = Topic.getThreadId(topicId)
    const blockName = Topic.getTopicName(topic) || userSelected
    const res = await BlockChatServices.switchBlockChat(userSelected, !isBlockUser)
    if (res && res.code == 200) {
      topic.isBlockUser = !isBlockUser
      topic.udpTopicInfo(topic)
      const id = MessagesUtil.xmppid();
      if (res.statusBlock && res.statusBlock === 1) {
        const body = formatMessage(messages.blockUser_content, { phoneName: blockName })
        this.props.tinode.addMessageNotify(topicId, NODE_TYPE_MESSAGE.CHAT, {
          body,
          timesend: new Date().getTime(),
          id,
        })
        if (topic && topic.acs && topic.acs.isWriter()) {
          topic.updateMode(null, '-W')
        }
        topic._processMetaDesc({});
      } else {
        const body = formatMessage(messages.unblockUser, { phoneName: blockName })
        this.props.tinode.addMessageNotify(topicId, NODE_TYPE_MESSAGE.CHAT, {
          body,
          timesend: new Date().getTime(),
          id,
        })
        topic.updateMode(null, '+W')
        topic._processMetaDesc({});
      }
    }
    this.setState({
      isBlockUser: !isBlockUser,
    });
  }

  handleToggleE2EChat = async () => {
    const { formatMessage } = this.props.intl;
    const { tinode, topic: topicId } = this.props;
    const topic = tinode.getTopicByName(topicId);
    const fromName = formatMessage(messages.you)
    const toName = Topic.getTopicName(topic)
    const secretStatus = !this.state.isCryptE2E ? '1' : '0'
    const id = MessagesUtil.xmppid()
    const data = {
      topicId,
      fromName,
      toName,
      timesend: new Date().getTime(),
      id,
    }
    this.props.tinode.sendSecretChatMessage(topic, secretStatus, id)
    this.props.tinode.setSecretChat(topic, secretStatus, data)
    this.setState({ isCryptE2E: !this.state.isCryptE2E })
  }

  handleSetPrivateGroup() {
    const { formatMessage } = this.props.intl;
    const { topic: tp, tinode } = this.props;
    const topic = tinode.getTopicByName(tp);
    if (Topic.isGroupTopicName(tp) && this.isGroupOwner(topic, profile.username)) {
      let groupPrivate
      if (topic?.public?.security === GROUP_PRIVATE_STATE.PRIVATE) {
        groupPrivate = GROUP_PRIVATE_STATE.NON_PRIVATE
      } else {
        groupPrivate = GROUP_PRIVATE_STATE.PRIVATE
      }
      this.props.setGroupPrivate(groupPrivate).then((resultData) => {
        if (resultData) {
          this.setState({
            isGroupPrivate: groupPrivate === GROUP_PRIVATE_STATE.PRIVATE,
          })
        }
      })
    } else {
      Helpers.showWarningToasts(formatMessage(messages.only_admin_can_use_this_feature_warning))
    }
  }

  onSubmit(e) {
    const keyCode = e.keyCode;
    if (keyCode === 13) {
      this.handleHideEdit();
      this.renameGroupMessage();
    }
    if (keyCode === 27) {
      this.handleHideEdit();
      this.handleSetTitle();
    }
  }

  handleOnFileSelectedChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.type && file.type.startsWith("image/")) {
      const mimeTypeAvvatar = file.type;
      let nameFileAvatar = "new_group_avatar";
      const newUrlAvatar = URL.createObjectURL(file);
      if (file.name !== undefined && file.name !== "") {
        nameFileAvatar = file.name;
      }
      this.setState({
        newAvatar: newUrlAvatar,
        newAvatarMime: mimeTypeAvvatar,
        fileAvatarName: nameFileAvatar,
      });
    } else {
      window.logger("handleOnFileSelectedChange wrong file image type");
    }
  };

  handleOnChangeAvatarButtonClick = () => {
    this.fileInput.click();
  };

  handleImageChanged(mime, img) {
    this.setState({ newAvatar: img, newAvatarMime: mime });
  }

  // AvatarCropView calls this method when the user has cropped the image.
  handleAvatarCropped(mime, blob, width, height, fileName) {
    const url = blob ? URL.createObjectURL(blob) : null;
    this.setState({ avatar: url, newAvatar: null, newAvatarMime: null });
    if (blob) {
      this.uploadAvatar(mime, blob, width, height, url);
    }
  }

  handleAvatarCropCancel() {
    this.setState({ newAvatar: null, newAvatarMime: null });
  }

  // Utility method for converting cropped avatar blob to bytes for sending inband or
  // for uploading it to the server out of band.
  async uploadAvatar(mime, blob, width, height, url) {
    const { fileAvatarName } = this.state;
    const readyToUpload = (image) => {
      let { mime, blob } = image;
      this.setState({ imageUrl: URL.createObjectURL(blob) });
      window.logger(
        "++++++++++++++uploadAvatar|mime=",
        mime,
        "|blob=",
        blob,
        "|width=",
        width,
        "|height=",
        height
      );
      const { topic } = this.props;
      const topicName = Topic.getThreadId(topic);
      window.logger(
        "++++++++++++++uploadAvatar|topicName=",
        topicName,
        "|url",
        url
      );
      if (blob.size > MAX_AVATAR_BYTES) {
        // Too large to send inband - uploading out of band and sending as a link.
        //upload avatar

        const uploader = this.uploadWithBaseUrl(
          topicName,
          blob,
          fileAvatarName
        );
        window.logger("++++++++++++++uploadAvatar=", uploader);
      } else {
        // Convert blob to base64-encoded bits.
        blobToBase64(blob).then((b64) =>
          this.setState({
            uploadUrl: makeImageUrl({ data: b64.bits, type: mime }),
          })
        );
      }
    };
    if (width > AVATAR_SIZE || height > AVATAR_SIZE || width != height) {
      // Avatar is not square or too large even after cropping. Shrink it and make square.
      imageScaled(
        blob,
        AVATAR_SIZE,
        AVATAR_SIZE,
        MAX_EXTERN_ATTACHMENT_SIZE,
        true
      )
        .then((scaled) => readyToUpload(scaled))
        .catch((err) => this.props.onError(err.message, "err"));
    } else {
      readyToUpload({ mime: mime, blob: blob, width: width, height: height });
    }
  }

  async uploadWithBaseUrl(groupId, blob, fileAvatarName) {
    const { formatMessage } = this.props.intl;
    const { tinode, topic: topicId } = this.props;
    const topic = tinode.getTopicByName(topicId);
    const file = new File([blob], fileAvatarName);
    return await fileService.uploadGroupAvatar(groupId, file).then((res) => {
      window.logger("uploadWithBaseUrl |res=", res);
      if (res && res.errorCode === "200" && res.avatar_date) {
        const groupAvatar = Helpers.getAvatarGroupURL(groupId, res.avatar_date);
        if (topic.public.photo) {
          topic.public.photo.ref = groupAvatar;
        } else {
          topic.public.photo = {
            ref: groupAvatar,
            type: Helpers.getFileExtension(fileAvatarName),
          };
        }
        topic._processMetaDesc({});
        this.setState({ avatar: groupAvatar })
        const id = MessagesUtil.xmppid();
        const body = formatMessage(messages.notify_changed_avatar_group)
        // this.props.tinode.addMessageNotify(topicId, NODE_TYPE_MESSAGE.GROUPCHAT, {
        //   body,
        //   timesend: new Date().getTime(),
        //   id,
        // })
      }
    });
  }

  handleDeleteHistoryMessage() {
    const { formatMessage } = this.props.intl;
    this.props.onShowAlert(
      formatMessage(messages.clear_messages), // title
      formatMessage(messages.clear_messages_warning), // content
      (_ => { this.deleteMessages(); }), // onConfirm
      null, // "OK"
      true, // Show Reject button
      null  // "Cancel"
    );
  }

  deleteMessages() {
    const topic = this.props.tinode.getTopic(this.props.topic);
    if (!topic) {
      console.warn("Topic not found: ", params.topicName);
      return;
    }
    topic.shareImage = [];
    topic.shareLink = [];
    topic.shareFile = [];
    topic.udpTopicInfo(topic)
    topic.delMessagesAll(true);
    // topic._processMetaDesc({});
  }

  handleDisbandTheGroup() {
    const { formatMessage } = this.props.intl;
    this.props.onShowAlert(
      formatMessage(messages.info_disband_group), // title
      formatMessage(messages.content_disband_group), // content
      (_) => this.props.dissolveGroup(),
      null, // "OK"
      true, // Show Reject button
      null  // "Cancel"
    );
  }

  setIsOpenLightbox = (listImages, indexImageInList) => {
    if (Array.isArray(listImages) && listImages.length > 0 && indexImageInList >= 0 && listImages[indexImageInList]) {
      this.setState({ isOpenLightbox: true, listImagesLightBox: listImages, indexImage: indexImageInList })
    }
  }

  isGroupOwner = (topicInfo, msisdn) => {
    const msisdnCheck = msisdn || profile.username;
    if (topicInfo && topicInfo._users) {
      for (const key in topicInfo._users) {
        if (Object.hasOwnProperty.call(topicInfo._users, key)) {
          const member = topicInfo._users[key];
          if (member.role === 'owner' && member.jid === msisdnCheck) {
            return true;
          }
        }
      }
    }
    return false
  }

  render() {
    const { tinode, topic, sharedImagePhotos } = this.props;
    const { edit, name, isEditAvatar } = this.state;
    const isGroup = Topic.isGroupTopicName(topic);
    const topicInfo = tinode.getTopic(topic);
    const isAdmin = this.isGroupOwner(topicInfo);
    if (this.state.newAvatar) {
      return (
        <AvatarCrop
          avatar={this.state.newAvatar}
          mime={this.state.newAvatarMime}
          onSubmit={this.handleAvatarCropped}
          onCancel={this.handleAvatarCropCancel}
          onError={this.props.onError}
        />
      );
    }

    return (
      <div className="info-list">
        {isGroup && (
          <div className="gr-info">
            <div>
              <div className="avatar">
                <LetterTile
                  tinode={this.props.tinode}
                  avatar={this.state.avatar || true}
                  title={name}
                  topic={topicInfo.topic || topicInfo.user}
                />
                {isEditAvatar && (
                  <input
                    type="file"
                    style={{
                      display: "none",
                    }}
                    accept="image/x-png,image/gif,image/jpeg"
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                    onChange={this.handleOnFileSelectedChange}
                    ref={(fileInput) => (this.fileInput = fileInput)}
                  />
                )}
                {isEditAvatar && (
                  <div
                    className="icon-change-avatar"
                    onClick={this.handleOnChangeAvatarButtonClick}
                  >
                    <IconChangeAvatarImage></IconChangeAvatarImage>
                  </div>
                )}
              </div>
            </div>
            <div className="infomation">
              <div className="name">
                {edit ? (
                  <input
                    autoFocus={true}
                    type="text"
                    onChange={this.onChange}
                    value={name}
                    onKeyUp={this.onSubmit}
                    onBlur={() => {
                      this.renameGroupMessage();
                      this.handleHideEdit();
                    }}
                  />
                ) : (
                  name
                )}
              </div>
              <div className="rename" onClick={this.handleShowEdit}>
                <button>
                  <FormattedMessage
                    id="info_button_rename_group"
                    defaultMessage="Rename the group"
                  />
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="gr-option">
          <div
            className="option"
            onClick={() => this.props.handleSetScreen(SCREEN.IMAGE)}
          >
            <div className="icon-l icon-custom-path">
              <IconChangeWallpaper />
            </div>
            <div className="name">
              <FormattedMessage
                id="info_image"
                defaultMessage="Media, links, files"
                description="Media, links, files"
              />
              {` (${this.props.sumContent ? this.props.sumContent : 0})`}
            </div>
            <div className="icon-r">
              {" "}
              <IconArrowRight />
            </div>
          </div>
          <div className="content-option">
            {sharedImagePhotos && Array.isArray(sharedImagePhotos) && sharedImagePhotos.length > 0 &&
              (sharedImagePhotos.slice(0, sharedImagePhotos.length > 3 ? 3 : sharedImagePhotos.length).map((message, index) => {
                const url = Helpers.getDownloadURL(message.media_link)
                const moreItemCount = index === 2 ? sharedImagePhotos.length - 3 : null
                return (
                  <div key={`shared_img_${message.messageId}`} className="img-info-container img">
                    <img
                      id={`settings_shared_img_${message.messageId}`}
                      src={url}
                      alt=""
                      onClick={() => {
                        this.setIsOpenLightbox(sharedImagePhotos, index);
                      }}
                    />
                    {index === 2 && moreItemCount && moreItemCount !== 0 &&
                      <div className="more-image-plus"
                        onClick={() => this.props.handleSetScreen(SCREEN.IMAGE)}
                      >
                        {`+${moreItemCount}`}
                      </div>
                    }
                  </div>
                )
              })
              )
            }
            {this.state.isOpenLightbox &&
              <YetAnotherLightbox
                showModalImage={this.state.isOpenLightbox}
                listImagesMessage={this.state.listImagesLightBox}
                indexImage={this.state.indexImage}
                setStateIndexImage={(index, openLightbox) => this.setState({ indexImage: index, isOpenLightbox: openLightbox })}
              />
            }
          </div>
        </div>

        <div className="gr-option">
          <div
            className="option"
            onClick={() => this.props.handleSetScreen(SCREEN.FIND_MESSAGE)}
          >
            <div className="icon-l icon-custom-path">
              <IconSearch />
            </div>
            <div className="name">
              <FormattedMessage
                id="info_search"
                defaultMessage="Search in chat"
                description="Search in chat"
              />
            </div>
            <div className="icon-r">
              {" "}
              <IconArrowRight />
            </div>
          </div>
        </div>
        <div className="gr-option" onClick={this.handleSetNotification}>
          <div className="option">
            <div className="icon-l icon-custom-path">
              <IconNotification />
            </div>
            <div className="name">
              <FormattedMessage
                id="info_notification"
                defaultMessage="Notifications"
                description="Notifications"
              />
            </div>
            <div className="icon-r"><Switch status={!topicInfo.acs.isMuted()} /></div>
          </div>
        </div>
        {!isGroup && (
          <div className="gr-option">
            <div className="option">
              <div className="icon-l icon-custom-path">
                <IconBlockUser />
              </div>

              <div className="name">
                {
                  this.state.isBlockUser ?
                    <FormattedMessage
                      id="info_unblock_user"
                      defaultMessage="Unblock this person"
                      description="Unblock this person"
                    />
                    :
                    <FormattedMessage
                      id="info_block_user"
                      defaultMessage="Block this person"
                      description="Block this person"
                    />
                }
              </div>

              <div className="icon-r">
                <Switch onClick={this.handleToggleBlockChat} status={this.state.isBlockUser} />
              </div>
            </div>
          </div>
        )}
        {!isGroup && (
          <div className="gr-option">
            <div className="option">
              <div className="icon-l icon-custom-path">
                <IconChatE2E />
              </div>

              <div className="name">
                <FormattedMessage
                  id="info_e2e_chat"
                  defaultMessage="Secret chat"
                  description="Secret chat"
                />
              </div>

              <div className="icon-r">
                <Switch onClick={this.handleToggleE2EChat} status={this.state.isCryptE2E} />
              </div>
            </div>
          </div>
        )}
        <div className="gr-option">
          <div
            className="option"
            onClick={() => this.props.handleSetScreen(SCREEN.BACKGROUND)}
          >
            <div className="icon-l icon-custom-path">
              <IconChatBackground />
            </div>
            <div className="name">
              <FormattedMessage
                id="info_change_background"
                defaultMessage="Change wallpaper"
              />
            </div>
            <div className="icon-r">
              {" "}
              <IconArrowRight />
            </div>
          </div>
        </div>
        {isGroup && (
          <div className="gr-option">
            <div className="option" onClick={() => this.props.handleSetScreen(SCREEN.MEMBERS)}>
              <div className="icon-l icon-custom-path"><IconPerson /></div>
              <div className="name">
                <FormattedMessage id="info_members" defaultMessage="Members" />
              </div>
              <div className="icon-r">
                {" "}
                <IconArrowRight />
              </div>
            </div>
          </div>
        )}
        {isGroup && (
          <div className="gr-option">
            <div className="option">
              <div className="icon-l icon-custom-path">
                <IconSecurity />
              </div>
              <div className="gr-name">
                <div className="name">
                  <FormattedMessage
                    id="info_security_group"
                    defaultMessage="Security group"
                  />
                </div>
                <div className="desc">
                  <FormattedMessage
                    id="info_security_group_descripion"
                    defaultMessage="Only admins can be added to the group"
                  />
                </div>
              </div>
              <div className="icon-r">
                {" "}
                <Switch onClick={this.handleSetPrivateGroup} status={this.state.isGroupPrivate} />
              </div>
            </div>
          </div>
        )}
        {isGroup && (
          <div className="gr-option" style={{ display: "none" }}>
            <div className="option">
              <div className="icon-l icon-custom-path">
                <IconEyeDisable />
              </div>
              <div className="name">
                <FormattedMessage
                  id="info_hide_chat"
                  defaultMessage="Hide chat"
                />
              </div>
              <div className="icon-r"></div>
            </div>
          </div>
        )}
        <div className="gr-option" onClick={this.handleDeleteHistoryMessage}>
          <div className="option">
            <div className="icon-l icon-custom-path">
              <IconTrash />
            </div>
            <div className="name">
              <FormattedMessage
                id="info_delete_message_history"
                defaultMessage="Delete message history"
              />
            </div>
            <div className="icon-r"> </div>
          </div>
        </div>
        {isGroup && <div className="gr-option" onClick={() => this.props.handleSetScreen(SCREEN.QR_INVITE_GROUP)}>
          <div className="option">
            <div className="icon-l icon-custom-path">
              <IconQRCode />
            </div>
            <div className="name">
              <FormattedMessage
                id="info_qr_code_invite"
                defaultMessage="QR code, group join link"
              />
            </div>
            <div className="icon-r"> </div>
          </div>
        </div>}
        {isGroup && isAdmin && (
          <div className="gr-option" onClick={this.handleDisbandTheGroup}>
            <div className="option">
              <div className="icon-l icon-custom-path">
                <IconPersonDisable />
              </div>
              <div className="name">
                <FormattedMessage
                  id="info_disband_group"
                  defaultMessage="Disband the group"
                />
              </div>
              <div className="icon-r"> </div>
            </div>
          </div>
        )}
        {isGroup && (
          <div className="gr-option">
            <div className="option" onClick={this.handleLeaveGroup}>
              <div className="icon-l">
                <IconLeave />
              </div>
              <div className="name">
                <FormattedMessage
                  id="info_leave_group"
                  defaultMessage="Leave the group"
                />
              </div>
              <div className="icon-r"> </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(Info);
